import { Box, Paper } from "@mui/material";
import DateRangeSelector2 from "components/DateRangeSeletor/DateRangeSelector2";
import moment from "moment";
import { useCoordinatorReport2Context } from "../useCoordinatorReport2";

export default function CoordinatorReport2Filter() {
  const { filter, setFilter } = useCoordinatorReport2Context();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
      }}
    >
      <Paper
        sx={{
          p: 1,
          display: "flex",
          alignItems: "center",
          flex: 1,
          alignSelf: "stretch",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            p: 1,
            display: "flex",
            alignItems: "center",
            flex: 1,
            alignSelf: "stretch",
            justifyContent: "center",
            gap: 2,
            flexWrap: "wrap",
            flexDirection: "column",
          }}
        >
          <DateRangeSelector2
            numberOfCalendars={1}
            numberOfYears={1}
            value={
              filter.from && filter.to
                ? { start: moment(filter.from), end: moment(filter.to) }
                : undefined
            }
            onChange={(start, end) => {
              setFilter({
                ...filter,
                from: start?.format("YYYY-MM-DD") ?? (null as any),
                to: end?.format("YYYY-MM-DD") ?? (null as any),
              });
            }}
            dateButtonMinWidth={240}
          />
        </Box>
      </Paper>
    </Box>
  );
}
